import axios from "axios";
import { PUBLIC_BUDGET_PRESETS } from "./publicCompetitionContract";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const PUBLIC_READ_TIMEOUT_MS = 15000;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  if (config.publicOnly === true) {
    config.headers?.delete?.("Authorization");
    if (config.headers) delete config.headers.Authorization;
    config.withCredentials = false;
    return config;
  }
  const token = localStorage.getItem("cc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const setToken = (token) => {
  if (token) localStorage.setItem("cc_token", token);
  else localStorage.removeItem("cc_token");
};

export default api;

export const formatGBP = (v) => {
  if (v == null) return "—";
  const n = Number(v);
  if (Number.isNaN(n)) return "—";
  return n.toLocaleString("en-GB", { style: "currency", currency: "GBP", maximumFractionDigits: 0 });
};

export const formatGBPDecimal = (v) => {
  if (v == null) return "—";
  return Number(v).toLocaleString("en-GB", { style: "currency", currency: "GBP", minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const formatNumber = (v) => {
  if (v == null) return "—";
  return Number(v).toLocaleString("en-GB");
};

export const daysUntil = (iso) => {
  if (!iso) return null;
  const ms = new Date(iso).getTime() - Date.now();
  return Math.ceil(ms / (1000 * 60 * 60 * 24));
};

export const scoreLabel = (s) => {
  if (s >= 80) return "Strong";
  if (s >= 65) return "Good";
  if (s >= 50) return "Mixed";
  return "Caution";
};

export const scoreColor = (s) => {
  if (s >= 80) return "var(--cc-good)";
  if (s >= 65) return "var(--cc-good)";
  if (s >= 50) return "var(--cc-warn)";
  return "var(--cc-bad)";
};

export const categoryLabel = (c) => ({
  cars: "Cars",
  bikes: "Bikes",
  watches: "Watches",
  cash: "Cash",
  tech: "Tech",
  gaming: "Gaming",
  lifestyle: "Lifestyle",
  luxury: "Luxury",
  other: "Other",
  // legacy fallbacks
  car: "Cars",
  vehicle: "Cars",
  vehicles: "Cars",
  bike: "Bikes",
  motorbike: "Bikes",
  motorcycle: "Bikes",
  watch: "Watches",
}[c] || c);

export const CATEGORIES = [
  "cars",
  "bikes",
  "watches",
  "cash",
  "tech",
  "gaming",
  "lifestyle",
  "luxury",
  "other",
];

export const QUICK_BUDGETS = PUBLIC_BUDGET_PRESETS;
